import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCategorySearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 19.5V11.5H8V19.5H0ZM2 17.5H6V13.5H2V17.5ZM3.5 9L9 0L14.5 9H3.5ZM7.05 7H10.95L9 3.85L7.05 7ZM19.575 21.95L16.925 19.3C16.575 19.5333 16.1958 19.7083 15.7875 19.825C15.3792 19.9417 14.95 20 14.5 20C13.25 20 12.1875 19.5625 11.3125 18.6875C10.4375 17.8125 10 16.75 10 15.5C10 14.25 10.4375 13.1875 11.3125 12.3125C12.1875 11.4375 13.25 11 14.5 11C15.75 11 16.8125 11.4375 17.6875 12.3125C18.5625 13.1875 19 14.25 19 15.5C19 15.9333 18.9417 16.3542 18.825 16.7625C18.7083 17.1708 18.5417 17.55 18.325 17.9L20.975 20.55L19.575 21.95ZM14.5 18C15.2 18 15.7917 17.7583 16.275 17.275C16.7583 16.7917 17 16.2 17 15.5C17 14.8 16.7583 14.2083 16.275 13.725C15.7917 13.2417 15.2 13 14.5 13C13.8 13 13.2083 13.2417 12.725 13.725C12.2417 14.2083 12 14.8 12 15.5C12 16.2 12.2417 16.7917 12.725 17.275C13.2083 17.7583 13.8 18 14.5 18Z",
		fill: "black"
	})
});
export default SvgCategorySearch;
